import React from "react";
import CampaignGroups from "../../client_config/ppc_config/CampaignGroups"

export default function Display(props) {
  
  const displayCampaignGroups = props.campaignGroups.display
  const allCampaignGroups = props.campaignGroups

  return (
   <div style={{backgroundColor:"#F5F5F5"}}>

    <CampaignGroups {...props} platformType="Display" campaignGroups={displayCampaignGroups} allCampaignGroups={allCampaignGroups} setCampaignGroups={props.setCampaignGroups} onboarding />
   </div>
  
  );
}